<div>
<h1 mat-dialog-title>
  <i class="far fa-user-lock i-16 mr-4"></i>
  <span>{{contentTypeName()}} Locked</span>
</h1>
<div mat-dialog-content>
  <p class="main c-grey-5 fs-14 text-center">
    {{contentName()}}
  </p>
  <p class="c-grey-5 fs-14 text-center">
    This {{contentTypeName()}} is being edited by <strong>{{lockedBy()}}</strong>
  </p>
  <p *ngIf="showNotificationButton" class="c-grey-5 fs-14 text-center">
    Do you want to be notified when the {{contentTypeName()}} is unlocked?
  </p>
</div>
<div mat-dialog-actions align="center">
  <button trgButton color="outline" class="min-w-100" (click)="close()">
    <span>Close</span>
  </button>
  <button *ngIf="showNotificationButton" 
          trgButton color="primary" class="min-w-100" (click)="addNotification()"
          cdkFocusInitial>
    <i class="far fa-bell-on i-12 mr-4"></i>
    <span>Notify Me</span>
  </button>
</div>
</div>
